import React, { useEffect, useRef, useState } from 'react';

import type { Address } from '../../../../Shared/js/@types/Address';
import { AddressSearchHandle } from '../../../../Shared/React/js/components/addressSearch/AddressAutocomplete';
import AddressSearch, {
    dispatchAddressChangedEvent
} from '../../../../Shared/React/js/components/addressSearch/AddressSearch';
import type { BroadbandAddressSearchModel } from '../../../js/@types/BroadbandAddressSearchModel';

type Props = BroadbandAddressSearchModel;

const BroadbandAddressSearch = (props: Props) => {
    const [address, setAddress] = useState<Address>(null);
    const ref = useRef<AddressSearchHandle>();

    useEffect(() => {
        if (props.autoFillAddress) {
            wo$.ajax({
                url: props.getCurrentAddressUrl,
                type: 'POST',
                success: result => {
                    if (result) {
                        setAddress(result);
                        dispatchAddressChangedEvent({
                            sender: ref.current,
                            address: result
                        });
                    }
                }
            });
        }
    }, [props.autoFillAddress, props.getCurrentAddressUrl]);

    return (
        <React.StrictMode>
            <AddressSearch
                current={address}
                apiKey={props.apiKey}
                countryCode={props.countryCode}
                queryDelay={props.queryDelay}
                inputClassName="font-5 input-lg"
                inputProps={{
                    type: 'text',
                    'data-address-input': true,
                    'data-address': true
                }}
                types={props.types}
                placeholder={props.text.addressSearchPlaceHolder}
            />
        </React.StrictMode>
    );
};

export default BroadbandAddressSearch;
